<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 7" id="Play" width="20" height="20"
  ><path
    fill="#ffffff"
    fill-rule="evenodd"
    d="M296.495 3608.573l-3.994-2.43c-.669-.408-1.501.107-1.501.926v4.862c0 .82.832 1.333 1.5.927l3.995-2.43c.673-.41.673-1.445 0-1.855"
    transform="translate(-291 -3606)"
    class="color000000 svgShape"
  /></svg
>
